
import DialogView from './DialogView.js';
/**
 * This class is to allow a more semantic way of displaying a dialog with only an OK button
 */
class AlertDialogView extends DialogView {}

export default AlertDialogView;